import { useState } from "react";
import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import {
  useGetCompanyAccountQuery,
  useUpdateCompanyAccountMutation,
} from "../../../../services/ScopeStackAPI";
import GenericToggle from "@components/FormsV2/GenericToggle/GenericToggle";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import ToastAlert from "@components/Alerts/ToastAlert/ToastAlert";
import { RootState } from "@reducers/rootReducer";
import "./style.css";

export const SalesApprovalSection = () => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const {
    data: account,
    isLoading,
    refetch,
  } = useGetCompanyAccountQuery(accountSlug as string, { skip: !accountSlug });
  const [updateCompanyAccount] = useUpdateCompanyAccountMutation();
  const [toast, setToast] = useState<{
    variant: "success" | "danger";
    text: string;
  } | null>(null);

  if (isLoading || !account) return <ScopeStackSpinner />;

  const settings = (account.attributes as any)?.settings ?? {};
  // sales_review is stored on Rails as a boolean string ("true"/"false") or boolean.
  const initialEnabled =
    settings.sales_review === true || settings.sales_review === "true";

  const handleToggle = async (next: boolean) => {
    try {
      await updateCompanyAccount({
        slug: accountSlug as string,
        data: {
          id: account.id,
          type: (account.type as string) ?? "accounts",
          attributes: {
            settings: { ...settings, sales_review: next },
          } as any,
        },
      } as any);
      await refetch();
      setToast({
        variant: "success",
        text: next
          ? "Sales executive approval enabled."
          : "Sales executive approval disabled.",
      });
    } catch {
      setToast({
        variant: "danger",
        text: "Could not update sales executive approval.",
      });
    }
  };

  return (
    <>
      <div className="salesApprovalSection">
        <div className="salesApprovalSection__toggleCell">
          <Form.Label>Add Sales Executive approval?</Form.Label>
          <GenericToggle
            key={`sales-review-${initialEnabled}`}
            initialValueOfIsOn={initialEnabled}
            onToggle={handleToggle}
            onText="Yes"
            offText="No"
            hasText
          />
        </div>
      </div>
      {toast && (
        <ToastAlert
          variant={toast.variant}
          text={toast.text}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};
